import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { BoxProps } from "./Box.types";
import { StyledBox } from "./Box.styles";
import React from "react";

const Box = React.forwardRef<HTMLElement, BoxProps>(
	({ className, ...props }, ref) => {
		const block = new BemIt("Box");

		return (
			<StyledBox
				ref={ref}
				className={addClass(className).after(block)}
				{...props}
			/>
		);
	}
);

export default Box;
